import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
const Hero = () => {
  return <div className="relative bg-gray-900 text-white" data-id="element-159">
      <div className="absolute inset-0 overflow-hidden" data-id="element-160">
        <img src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Automatic driving lessons in Northampton with DVSA-approved instructors - modern car interior" className="w-full h-full object-cover opacity-30" data-id="element-161" />
      </div>
      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-162">
        <div className="max-w-3xl" data-id="element-163">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-164">
            Pass Faster. Drive Smarter.
          </h1>
          <p className="text-xl md:text-2xl mb-8" data-id="element-165">
            Automatic driving lessons in Northampton with patient instructors,
            flexible times, and high pass rates.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 flex-wrap" data-id="element-166">
            <a href="https://www.totaldrive.app/a/onlinebooking.php?175871549079721" target="_blank" rel="noopener noreferrer" className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-md font-medium text-center transition-colors" aria-label="Book your driving lessons now" data-id="element-167">
              Book Now
            </a>
            <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium text-center transition-colors" aria-label="Book your trial driving lesson for £40" data-id="element-168">
              Book Your Trial for £40
            </a>
            <Link to="/standard-lessons" className="bg-white hover:bg-gray-100 text-gray-800 px-6 py-3 rounded-md font-medium text-center transition-colors" aria-label="View our automatic driving lessons packages" data-id="element-169">
              View Packages
            </Link>
            <a href="tel:07481300600" className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium transition-colors" aria-label="Call us to book driving lessons" data-id="element-170">
              <Phone size={18} aria-hidden="true" data-id="element-171" />
              Call Us: 07481 300 600
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default Hero;